import { render } from "./ScoreAGJ.vue?vue&type=template&id=016a726a&scoped=true"
import script from "./ScoreAGJ.vue?vue&type=script&lang=js"
export * from "./ScoreAGJ.vue?vue&type=script&lang=js"

import "./ScoreAGJ.vue?vue&type=style&index=0&id=016a726a&scoped=scoped&lang=less"
import "./ScoreAGJ.vue?vue&type=style&index=1&id=016a726a&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016a726a"]])

export default __exports__